import { fetchApi } from "../fetchApi";

export async function getPostComments({ id = null, platform = "" }) {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {},
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };
  return fetchApi({
    requestOptions,
    endpoint: `/contact_center/get_comments/${platform}/${id}`,
  });
}
